import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Manages inter-component scroll synchronization through a pub/sub pattern.
 */
@Injectable({
  providedIn: 'root'
})
export class ScrollTriggerService {
  /** Subject for broadcasting model scroll events */
  private modelScrollTrigger = new Subject<string>();

  /** Observable stream of model scroll events */
  modelScrollTrigger$ = this.modelScrollTrigger.asObservable();

  /**
   * Emits a scroll event for the specified model
   * @param modelId - Target model identifier
   */
  triggerScrollToModel(modelId: string) {
    this.modelScrollTrigger.next(modelId);
  }
}
